<template>
  <div class="hotlineCall" v-if="showDom">
    <OrderEdit v-show="!operateVisible" :editType="editType" :orderId="orderId" :dialogShow="dialogShow" :cusColumns="cusColumns" :cusPanyColumns="cusPanyColumns"
      :hotlineObj="hotlineObj" :fromPage="'hotline'"></OrderEdit>
    <div v-show="operateVisible">
      <OrderEdit v-if="operateVisible" :editType="hdeditType" :orderId="hdorderId" :dialogShow="operateVisible" :cusColumns="cusColumns" :cusPanyColumns="cusPanyColumns" 
        :fromPage="fromPage"></OrderEdit>
    </div>
  </div>
</template>

<script>
  import { getFormColumnList } from '@/http/Customfield.js'
  import OrderEdit from '../components/OrderEdit.vue'

  export default {
    components: { OrderEdit },
    //editType修改类型 info：查看 add：新增 edit：编辑 examine：审批 supervise：督办 hotline：弹屏
    data() {
      return {
        vdnId: '',
        cusColumns: [],
        cusPanyColumns: [],
        editType: 'hotline',
        orderId: '',
        dialogShow: true,
        operateVisible: false,
        hdeditType: '',
        hdorderId: '',
        fromPage: 'hotlineDialog',
        hotlineObj: {
          originType: '', //渠道类型
          originId: '', //渠道id
          vId: '', //访客id
          nikeName: '', //访客昵称
          sourceId: '', //来源id
        },
        showDom: false
      }
    },
    watch: {
      
    },
    mounted() {
      setTimeout(()=>{
        this.vdnId = JSON.parse(LocalStorage.getItem("obj")).vdnId
        this.showDom = true;
        this.hotlineObj.originType = this.$route.query['originType'] || 'CALLCENTER'
        this.hotlineObj.originId = this.$route.query['originId'] || ''
        this.hotlineObj.vId = this.$route.query['vId'] || ''
        this.hotlineObj.nikeName = this.$route.query['nikeName'] || ''
        this.hotlineObj.sourceId = this.$route.query['sourceId'] || ''
        this.fetchFormColumnList(1) //获取客户信息字段
        this.fetchFormColumnList(2) //获取客户公司信息字段
      }, 1000)
    },
    created() {

    },
    methods: {
      //获取客户编辑字段信息
      fetchFormColumnList(type, id) {
        getFormColumnList({
          vdnId: this.vdnId,
          configType: type
        }).then(res => {
          if(res && res.retCode == 1){
            if (type == 1) {
              this.cusColumns = res.data
            } else {
              this.cusPanyColumns = res.data
            }
          }
        })
      },
    }
  }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// hotlineCall.vue?c4de7c3e